export default __webpack_public_path__ + "static/stay-wild-50c53a6001d25c120e9ac2ae7d2215a3.woff2";